import React, { useState } from 'react';

import Divider from '@mui/material/Divider';

import { SelectedTemplateWithAction } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates';
import { getTemplateById } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.utils';
import { CreateReportFromTemplateModal } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/InitialTemplateCard.module.scss';
import { useInitialTemplateCardProvider } from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/InitialTemplateCard.provider';
import { useInitialTemplateCardsLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/InitialTemplateCards.Logic';
import { TemplateSection } from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/components/TemplateSection/TemplateSection';

export const InitialTemplateCards = () => {
    const [selectedTemplate, setSelectedTemplate] = useState<SelectedTemplateWithAction | null>(null);
    const { api } = useInitialTemplateCardProvider();
    const { logic } = useInitialTemplateCardsLogic({ api });

    const closeModal = () => {
        setSelectedTemplate(null);
    };

    return (
        <>
            <Divider className={classes.divider}>OR</Divider>
            <TemplateSection
                setSelectedTemplate={setSelectedTemplate}
                title={'Start from a template built by Foresight:'}
                templates={logic.foresightTemplateList}
            />
            <Divider className={classes.divider}>OR</Divider>
            <TemplateSection
                setSelectedTemplate={setSelectedTemplate}
                title={'Start from a template built by your team:'}
                templates={logic.usersTemplateList}
            />
            <CreateReportFromTemplateModal
                template={
                    selectedTemplate
                        ? getTemplateById(selectedTemplate.templateId, api.getReportTemplates.data ?? [])
                        : null
                }
                isShowModal={selectedTemplate !== null && selectedTemplate.action === 'createReport'}
                closeModal={closeModal}
            />
        </>
    );
};
